import script from "./PoolPageHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./PoolPageHeader.vue?vue&type=script&lang=ts&setup=true"

import "./PoolPageHeader.vue?vue&type=style&index=0&id=412aa014&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412aa014"]])

export default __exports__